import request from "@/api/request";

//文章收藏
export function articleCollect(data) {
  return request({
    url: "/api/kp/article/articleCollect",
    method: "post",
    data: data,
  });
}

//文章预览

// 获取文章一级分类
export function GetFirstLevelClassification(query) {
  return request({
    url: "/api/kp/sort/getFirstSort",
    method: "get",
    params: query,
  });
}

// 获取文章二级分类
export function GetSecondLevelClassification(query) {
  return request({
    url: "/api/kp/sort/getSecondSort",
    method: "get",
    params: query,
  });
}

//添加一级分类

export function addTopSort(data) {
  return request({
    url: "/api/kp/sort/addTopSort",
    method: "post",
    data: data,
  });
}
/**
 * 保存文章
 * @param {*} data
 * @returns
 */
export function saveArticle(data) {
  return request({
    url: "/api/kp/article/saveArticle",
    method: "post",
    data: data,
  });
}

/**
 * 修改文章
 * @param {*} data
 * @returns
 */
export function updateKpArticle(data) {
  return request({
    url: "/api/kp/article/updateKpArticle",
    method: "post",
    data: data,
  });
}

//新增分类
export function addSort(data) {
  return request({
    url: "/api/kp/sort/addSort",
    method: "post",
    data: data,
  });
}
//删除分类u
export function deleteSort(data) {
  return request({
    url: "/api/kp/sort/deleteSort",
    method: "delete",
    data: data,
  });
}
//更改分类名
export function updateSort(data) {
  return request({
    url: "/api/kp/sort/updateSort",
    method: "put",
    data: data,
  });
}

// 文章上传
export function UplpadArticle(data) {
  return request({
    url: "/api/kp/article/startUpload",
    method: "post",
    data: data,
  });
}

//保存上传文章
export function SaveUploadArticle(data) {
  return request({
    url: "/api/kp/article/saveUploadArticle",
    method: "post",
    data: data,
  });
}
//获取文章来源
export function selectSourcesByUserId(data) {
  return request({
    url: "/api/kp/article/selectSourcesByUserId",
    method: "get",
    params: data,
  });
}

//通过文章id获取作者id
export function getInfoByArticleId(data) {
  return request({
    url: "/api/kp/ArticleUser/articleId",
    method: "get",
    params: data,
  });
}
//查询文章
export function selectArticles(data) {
  return request({
    url: "/api/kp/article/selectArticles",
    method: "post",
    data,
  });
}

//根据一级分类查询文章
export function selectArticleListByFirstSortId(data) {
  return request({
    url: "/api/kp/article/selectArticleListByFirstSortId",
    method: "post",
    data,
  });
}
//获取所有tag
export function getAllTag(query) {
  return request({
    url: "/api/kp/article/getLabelList",
    method: "get",
    params: query,
  });
}
//统计当前用户收藏文章数
export function getColNum() {
  return request({
    url: "/api/kp/article/getColNum",
    method: "get",
  });
}
//统计当前用户上传文章数
export function getUploadNum() {
  return request({
    url: "/api/kp/article/getUploadNum",
    method: "get",
  });
}
//统计当前用户文章来源数
export function getSourcesNum() {
  return request({
    url: "/api/kp/article/getSourcesNum",
    method: "get",
  });
}
export function apiAddTag(data) {
  return request({
    url: "/api/kp/label",
    method: "post",
    data: data,
  });
}

export function exportToLocalPdf(data) {
  return request({
    url: "/api/kp/article/exportToLocalPdf",
    method: "get",
    params: data,
    responseType: "arraybuffer",
  });
}
export function exportToLocal(params) {
  return request({
    url: "/api/kp/article/exportToLocal",
    method: "get",
    params: params,
    responseType: "arraybuffer",
  });
}
export function deleteArticle(data) {
  return request({
    url: "/api/kp/article/deleteArticle",
    method: "post",
    data,
  });
}
export function articleContent(data) {
  return request({
    url: "/api/kp/article/articleContent",
    method: "post",
    data,
  });
}


export function articleInfo(data) {
  return request({
    url: "/api/kp/article/articleInfo",
    method: "post",
    data,
  });
}

export function shareArticleInfo(params) {
  return request({
    url: "/api/kp/article/share/info",
    method: "get",
    params,
  });
}

export function shareArticleContent(params) {
  return request({
    url: "/api/kp/article/share/content",
    method: "get",
    params,
  });
}

export function shareArticleDownload(params) {
  return request({
    url: "/api/kp/article/share/download",
    method: "get",
    params,
  });
}

//分享历史，我收到的
export function receiveArticleInfo(params) {
  return request({
    url: "/api/kp/article/receiveArticleInfo",
    method: "get",
    params,
  });
}
export function receiveArticleContent(params) {
  return request({
    url: "/api/kp/article/receiveArticleContent",
    method: "get",
    params,
  });
}

